// Badge.tsx
import React from 'react';
import { BadgeProps } from '@/components/badge/types';
import { badgeVariants, getUppercaseClass, sizeClasses } from './const';
import { renameDomProps } from '@/utils/sanitizeDomProps';

export function Badge({
  variant,
  size = 'small',
  title,
  uppercase = true,
  classNameBadge,
  ...rest
}: BadgeProps) {
  const badgeClass = `smzh-badge ${badgeVariants[variant]} ${sizeClasses[size]} ${getUppercaseClass(uppercase)} rounded-md w-fit ${classNameBadge}`;
  const renamedProps = renameDomProps(rest);

  return (
    <div
      data-component-id="C015"
      className={badgeClass}
      role="status"
      aria-label={variant}
      {...renamedProps}
    >
      <span className="badge-content">{title}</span>
    </div>
  );
}

export default Badge;
